import { SHOPPABLE_PLUGIN } from '~/utils/constants';

export const checkMikMakV1Available = (
  shoppablePlugin?: string,
  mikmak?: {
    appId?: string;
    buttonText?: string;
  }
) =>
  (mikmak &&
    (SHOPPABLE_PLUGIN.MIKMAK_DEPRECATED === shoppablePlugin ||
      SHOPPABLE_PLUGIN.MIKMAK_V1 === shoppablePlugin) &&
    Boolean(mikmak.appId && mikmak.buttonText)) ||
  false;

export const checkMikMakV2Available = (
  shoppablePlugin?: string,
  mikmak?: {
    appId?: string;
    widgetId?: string;
    buttonText?: string;
  }
) =>
  (mikmak &&
    SHOPPABLE_PLUGIN.MIKMAK_V2 === shoppablePlugin &&
    Boolean(mikmak.appId && mikmak.widgetId && mikmak.buttonText)) ||
  false;
